var map = {
	"./example.svg": 16451,
	"./eye.svg": 13822,
	"./form.svg": 86525,
	"./home.svg": 84674,
	"./login-mall.svg": 16729,
	"./marker.svg": 6989,
	"./order-return-reason.svg": 57345,
	"./order-return.svg": 35584,
	"./order-setting.svg": 2814,
	"./order.svg": 23789,
	"./password.svg": 77232,
	"./product-add.svg": 33162,
	"./product-attr.svg": 86388,
	"./product-brand.svg": 19100,
	"./product-cate.svg": 50232,
	"./product-comment.svg": 20140,
	"./product-list.svg": 30337,
	"./product-recycle.svg": 1748,
	"./product.svg": 68820,
	"./sms-ad.svg": 9760,
	"./sms-coupon.svg": 90785,
	"./sms-flash.svg": 94984,
	"./sms-hot.svg": 27212,
	"./sms-new.svg": 86355,
	"./sms-subject.svg": 42565,
	"./sms.svg": 55342,
	"./table.svg": 7285,
	"./total-today.svg": 8467,
	"./total-week.svg": 89284,
	"./total-yesterday.svg": 92420,
	"./tree.svg": 59223,
	"./ums-admin.svg": 8630,
	"./ums-menu.svg": 33308,
	"./ums-resource.svg": 51861,
	"./ums-role.svg": 83357,
	"./ums.svg": 51332,
	"./user.svg": 23574
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;